import {useCodeViewOptions} from '@github-ui/use-code-view-options'
import {SplitPageLayout} from '@primer/react'
import React from 'react'

import styles from './SharedPageLayout.module.css'

export const REPOS_SPLIT_PANE_CONTENT_ID = 'repos-split-pane-content'
export const REPOS_FILE_TREE_SIDEBAR_ID = 'repos-file-tree-sidebar'

export function SharedPageLayout({
  sidebar,
  children,
  narrow,
  endSidebar,
}: React.PropsWithChildren<{sidebar?: React.ReactNode; narrow: boolean; endSidebar?: React.ReactNode}>) {
  const {codeCenterOption} = useCodeViewOptions()

  return (
    <SplitPageLayout>
      {sidebar}
      <SplitPageLayout.Content
        as="div"
        padding="none"
        width={codeCenterOption.enabled ? 'xlarge' : 'full'}
        hidden={{narrow}}
      >
        <div
          className={styles.content}
          data-selector="repos-split-pane-content"
          id={REPOS_SPLIT_PANE_CONTENT_ID}
          // tabIndex is required for keyboard focus management in CodeViewLayout's toggleFocus
          // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
          tabIndex={0}
        >
          {children}
        </div>
      </SplitPageLayout.Content>
      {endSidebar}
    </SplitPageLayout>
  )
}
